import React, { useEffect, useState } from "react";
import {
  ProjectDataContainer,
  ProjectImageContainer,
  ProjectOverviewContainer,
  ProjectCardExpanded,
  ExpandedScreen,
} from "./projectOverview.styles";

import "./projectOverview.styles.css";
import { AnimateSharedLayout } from "framer-motion";
import { Fade } from "react-reveal";

import ProjectExpandedCard from "./projectExpandedCard.component";

const ProjectOverview = ({ project, selectProject, disabled }) => {
  const [isHovered, setIsHovered] = useState(false);
  const [isSelected, setIsSelected] = useState(false);

  const selectCurrentProject = () => {
    if (!disabled) {
      selectProject(project?.id);
      setIsSelected(true);
    }
  };

  const deselectProject = () => {
    selectProject(null);
    setIsSelected(false);
  };

  return (
    <>
      <AnimateSharedLayout>
        {isSelected ? (
          <ProjectExpandedCard project={project} closeCard={deselectProject} />
        ) : (
          <ProjectOverviewContainer
            transition={{ ease: "easeOut", duration: 0.5 }}
            id={`sp-${project.name}`}
            onMouseEnter={() => {
              if (!disabled) {
                setIsHovered(true);
              }
            }}
            onMouseLeave={() => {
              if (!disabled) {
                setIsHovered(false);
              }
            }}
            onClick={selectCurrentProject}
            layoutId={`${project.name}`}
          >
            <ProjectImageContainer url={project?.images[0]} disabled={disabled}>
              {isHovered ? (
                <Fade bottom>
                  <ProjectDataContainer>
                    <div className="project-name">{project.name}</div>
                    <div className="project-description">
                      {project.overview || "this is temporary"}
                    </div>
                  </ProjectDataContainer>
                </Fade>
              ) : (
                <>
                  <ProjectDataContainer style={{ visibility: "hidden" }}>
                    <div className="project-name">{project.name}</div>
                    <div className="project-description">
                      {project.overview || "this is temporary"}
                    </div>
                  </ProjectDataContainer>
                </>
              )}
            </ProjectImageContainer>
          </ProjectOverviewContainer>
        )}
      </AnimateSharedLayout>
    </>
  );
};

export default ProjectOverview;
